import cn from 'classnames';
import React, { useEffect, useState } from 'react';

interface Props {
  afterMs: number;
  untilThenRender?:
    | React.ReactElement
    | null
    | (() => React.ReactElement | null);
}

const Reveal: React.FC<Props> = ({ afterMs, untilThenRender, children }) => {
  const [state, setState] = useState<'visible' | 'hidden'>('hidden');

  useEffect(() => {
    const timer = setTimeout(() => setState('visible'), afterMs);
    return () => {
      clearTimeout(timer);
    };
  }, [afterMs]);

  if (state === 'hidden' && untilThenRender) {
    return typeof untilThenRender === 'function'
      ? untilThenRender()
      : untilThenRender;
  }

  return (
    <div className={cn({ 'jg-invisible': state === 'hidden' })}>{children}</div>
  );
};

export default Reveal;
